import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex, Row, Text } from 'Components/UI'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Flex)
  .attrs({
    width: 1,
    justifyContent: 'center',
    px: LANDING_INLINE_PADDINGS,
    py: [0, 24],
  })
  .withConfig({
    shouldForwardProp,
  })`
  background-color: ${themeGet('colors.bg.secondary')};
`

export const Content = styled(Flex)`
  width: 100%;
  flex-direction: column;
  border-radius: 24px;
  overflow: hidden;
  background-color: ${themeGet('colors.white')};
`

export const ImageHolder = styled(Row).attrs({
  pt: ['80%', '40.91%'],
})`
  width: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 24px;
  background-color: ${themeGet('colors.bunting')};

  div:first-child {
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* This holder sizes the image from its own padding-top ratio and these
       four insets, not from the image. The wrapper Image renders carries an
       aspect-ratio (the blog *card* holder has no height of its own and needs
       it), but here that ratio over-constrains the box: CSS drops the
       bottom inset, so the wrapper is solved from the source's ratio rather
       than the holder's, and anything not ~2.44:1 overflows and crops
       off-centre - a 1024x1024 hero measured 1360x1360 in a 1360x556 box. */
    aspect-ratio: auto !important;
  }

  img {
    max-width: unset !important;
    width: 100%;
    object-fit: cover;
  }
`

export const Title = styled(Text).attrs({
  fontSize: [16, 16, 32, 32, 48],
})`
  position: absolute;
  max-width: 90%;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  line-height: 1.33;
  letter-spacing: 1px;
  font-weight: 500;
  color: ${themeGet('colors.white')};
  text-align: center;
`

export const PublishDate = styled(Text).attrs({
  fontSize: [14, 20],
  width: 1,
})`
  position: absolute;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  z-index: 2;
  line-height: 3.4;
  letter-spacing: 0.63px;
  font-weight: 300;
  color: ${themeGet('colors.white')};
  text-align: center;

  @media screen and (max-width: ${themeGet('breakpoints.0')}) {
    line-height: 1;
    bottom: 8px;
  }
`
